import { FaroCoreApiTypes } from "@stellar/core-api-client";
import {
  UNLIMITED,
  formatLimitType,
  formatLimitValue,
} from "@utils/limit-data-display";
import { NumberUtils } from "@stellar/utils";

interface LimitsProps {
  /** All the limits */
  limits: FaroCoreApiTypes.LimitPayload[];

  /** Number of SCENE seats included in the plan. Nothing is shown when there are none */
  sceneSeatsCount?: number;

  /** Number of tokens every year of the plan grants. Nothing is shown when there are none */
  tokensPerYear?: number;
}

/** A component to display limits in a human readable format */
export function LimitsReport({
  limits,
  sceneSeatsCount = 0,
  tokensPerYear = 0,
}: LimitsProps): React.JSX.Element {
  if (!limits.length && !sceneSeatsCount && !tokensPerYear) {
    return <span>{UNLIMITED}</span>;
  }

  return (
    <>
      {limits.map((limit) => (
        <span key={limit.type}>
          {formatLimitValue({ type: limit.type, value: limit.value })}
          <br />
        </span>
      ))}
      {sceneSeatsCount > 0 && (
        <span>
          {NumberUtils.formatNumberWithSpaces(sceneSeatsCount)}{" "}
          {formatLimitType("SCENE_SEAT", sceneSeatsCount)}
          <br />
        </span>
      )}
      {tokensPerYear > 0 && (
        <span>
          {NumberUtils.formatNumberWithSpaces(tokensPerYear)}{" "}
          {formatLimitType("CREDITS", tokensPerYear)} per year
          <br />
        </span>
      )}
    </>
  );
}
